import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=5108e217"
import script from "./FormDialog.vue?vue&type=script&lang=js"
export * from "./FormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports